import { css, cx } from "@emotion/css"

import useFocusVisible from "@p-ban/common/src/hooks/useFocusVisible"
import useHover from "@p-ban/common/src/hooks/useHover"

import COLOR_CODE from "../../../../constant/color"

type Props = JSX.IntrinsicElements["input"] & {
  labelClickable?: boolean
  children?: React.ReactNode
}

const CheckBox = ({ children, checked = false, disabled = false, labelClickable = true, ...props }: Props) => {
  const { isHovered, hoverProps } = useHover()
  const { isFocusVisible, focusVisibleProps } = useFocusVisible()

  const Wrapper = labelClickable ? "label" : "div"

  return (
    <Wrapper
      {...hoverProps}
      className={cx(styles.default, !disabled && isHovered && styles.hover, isFocusVisible && styles.focus)}
    >
      <input {...props} {...focusVisibleProps} checked={checked} disabled={disabled} type="checkbox" />
      {children}
    </Wrapper>
  )
}

export default CheckBox

const styles = {
  default: css`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    > input {
      outline: none;
      accent-color: #14a651;
    }
  `,
  hover: css`
    opacity: 0.7;
  `,
  focus: css`
    outline: solid 2px ${COLOR_CODE.FOCUS_GRAY};
  `,
}
